import { ContentPageTheme, PublicReviewWidget, PublicReviewWidgetReview, ReviewWidgetConfig } from "@/services/bedrock";
import { DUMMY_REVIEWS, DummyReview, SAMPLE_THEME, buildSampleSummary } from "../../components/sampleReviews";

const toPublicReview = ({ approvedForSocial: _approvedForSocial, ...review }: DummyReview): PublicReviewWidgetReview =>
  review;

const buildReviewList = (config: ReviewWidgetConfig): PublicReviewWidgetReview[] => {
  const filtered = config.approvedForSocialOnly
    ? DUMMY_REVIEWS.filter(review => review.approvedForSocial)
    : DUMMY_REVIEWS.slice();
  let reviews = filtered.map(toPublicReview);

  if (config.reviewSortType === "latest") {
    reviews.reverse();
  }

  return reviews;
};

export const buildReviewWidgetPreviewData = (
  config: ReviewWidgetConfig,
  themes: ContentPageTheme[]
): PublicReviewWidget => {
  const theme =
    (config.contentPageThemeId ? themes.find(item => item.id === config.contentPageThemeId) : null) ?? SAMPLE_THEME;

  const reviews = buildReviewList(config);
  const summary = buildSampleSummary(config);

  return {
    reviewSortType: config.reviewSortType,
    useCondensedQuotes: config.useCondensedQuotes,
    autoScrollEnabled: config.autoScrollEnabled,
    playerDisplayName: "Alex Smith",
    formUrl: "#write-a-review",
    reviewPageUrl: "#view-all-reviews",
    summary,
    theme,
    reviews,
  };
};
